export * from './_departamento-card/departamento-card.component';
export * from './_departamentos-skel/departamentos-skel.component';
export * from './_item-carrinho-preco/item-carrinho-preco.component';
export * from './_pedido-itens/pedido-itens.component';
export * from './_pedidos-list-skel/pedidos-list-skel.component';
export * from './_pedido-timeline/pedido-timeline.component';
export * from './_produto-botao-comprar-skel/produto-botao-comprar-skel.component';  
export * from './_produto-preco/produto-preco.component'; 
export * from './_produtos-skel/produtos-skel.component';
